const DISPLAY_MODAL = 'DISPLAY_MODAL';
const HIDE_MODAL = 'HIDE_MODAL';

export {
  DISPLAY_MODAL,
  HIDE_MODAL
}